import React, { FC, Dispatch, SetStateAction } from "react";
import { NavLink } from "../components/NavLink";
import { Box, makeStyles, Drawer, Typography } from "@material-ui/core";
import { useIdentityContext } from "react-netlify-identity";
import { store } from "../store";
import { observer } from "mobx-react-lite";
import { ToggleImperial } from "./ToggleImperial";
import packageJson from "../../package.json";
interface ISidebarProps {
  toggleSidebar: Dispatch<SetStateAction<boolean>>;
  sidebar: boolean;
  children?: React.ReactNode;
}

export const Sidebar: FC<ISidebarProps> = observer(
  ({ sidebar, toggleSidebar }) => {
    const classes = styles();
    const { user, resetDesigns } = store;
    const { logoutUser } = useIdentityContext();

    return (
      <Drawer
        onClose={() => toggleSidebar(false)}
        anchor="right"
        open={sidebar}
      >
        <Box className={classes.container}>
          {user ? (
            <Box>
              <Box
                onClick={() => {
                  try {
                    logoutUser?.();
                  } catch {}
                  resetDesigns();
                }}
              >
                <NavLink close={() => toggleSidebar(false)} to="/">
                  LOGOUT
                </NavLink>
              </Box>
              <NavLink close={() => toggleSidebar(false)} to="/account">
                MY ACCOUNT
              </NavLink>
            </Box>
          ) : (
            <NavLink close={() => toggleSidebar(false)} to="/login">
              LOGIN
            </NavLink>
          )}
          <NavLink close={() => toggleSidebar(false)} to="/mydesigns">
            MY DESIGNS
          </NavLink>
          <NavLink close={() => toggleSidebar(false)} to="/faq">
            FAQ
          </NavLink>
          <NavLink close={() => toggleSidebar(false)} to="/terms">
            TERMS & CONDITIONS
          </NavLink>
          <NavLink close={() => toggleSidebar(false)} to="/privacy">
            PRIVACY & COOKIE POLICY
          </NavLink>
          <NavLink close={() => toggleSidebar(false)} to="/acceptableUse">
            ACCEPTABLE USE POLICY
          </NavLink>
          <Box display="flex" alignItems="center">
            <Typography>UNITS:</Typography>
            <ToggleImperial />
          </Box>
          <Box color="lightgrey" position="absolute" bottom="1em" right="1em">
            {packageJson.version}
          </Box>
        </Box>
      </Drawer>
    );
  }
);

const styles = makeStyles(() => ({
  container: {
    padding: "50px 50px 0px 20px",
  },
}));
